/* eslint-disable no-console */
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Checkbox,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { updateMechanical } from 'src/redux-store/slices/constructionFormSlice';

interface TypeOption {
  label: string;
  value: string;
  checked: boolean;
}

const MechanicalCharacteristics: React.FC = () => {

  const dispatch = useDispatch()

  const [options, setOptions] = useState<TypeOption[]>([
    { label: 'Hydronic', value: 'Hydronic', checked: false },
    { label: 'Hot Air', value: 'Hot Air', checked: false }
  ]);

  const heatingSystemType = useSelector(
    (state: RootState) => state.constructionFormSlice.Mechanical.HeatingSystemType
  );
  const fuelType = useSelector(
    (state: RootState) => state.constructionFormSlice.Mechanical.FuelType
  );
  const subCodesFormData = useSelector(
    (state: RootState) => state.constructionFormSlice.Mechanical
  );

  const [fuelTypeOptions, setFuelTypeOptions] = useState<TypeOption[]>([
    { label: 'Gas', value: 'Gas', checked: false },
    { label: 'Oil', value: 'Oil', checked: false },
    { label: 'Electric', value: 'Electric', checked: false },
    { label: 'Solar', value: 'Solar', checked: false },
    { label: 'Other', value: 'Other', checked: false }
  ]);

  const handleChange = (index: number, field, value) => {

    const updatedHeatingSystemType = [...heatingSystemType];
    updatedHeatingSystemType[index] = {...updatedHeatingSystemType[index], [field]: value}

    dispatch(
            updateMechanical({
              HeatingSystemType: updatedHeatingSystemType
            })
          );

    console.log("updatedHeatingSystemType", updatedHeatingSystemType)

    const newOptions = [...options];
    newOptions[index].checked = !newOptions[index].checked;
    setOptions(newOptions);

    // Internal onChange function
    const selectedValues = newOptions
      .filter(option => option.checked)
      .map(option => option.value);

    console.log('Selected types:', selectedValues);
  };

  const handleChange1 = (index: number, field, value) => {

    const updatedFuelType = [...fuelType];
    updatedFuelType[index] = {...updatedFuelType[index], [field]: value}

    console.log("updatedHeatingSystemType", updatedFuelType)

    dispatch(
      updateMechanical({
        FuelType: updatedFuelType
      })
    );

    const newOptions = [...fuelTypeOptions];
    newOptions[index].checked = !newOptions[index].checked;
    setFuelTypeOptions(newOptions);

    // Internal onChange function
    const selectedValues = newOptions
      .filter(option => option.checked)
      .map(option => option.value);

    console.log('Selected fuel types:', selectedValues, subCodesFormData);
  };

  // Check if "Other" is selected in fuel type
  // const isOtherSelected = fuelTypeOptions.find(option => option.value === 'other')?.checked;

  return (
    <Grid container>
      {/* Left Grid - Estimation fields */}
      <Grid item md={12} sm={12}>
        <Typography variant="h5">
          Estimated Cost Of Work
        </Typography>
        <Box sx={{ mt: 2, mb: 3 }}>
          <TextField
            fullWidth
            label={
              <span>
                Mechanical Work Cost <span style={{ color: 'red' }}>*</span>
              </span>
            }
            type="number"
            value={subCodesFormData?.TotalEstimateCost || ''}
            variant="outlined"
            onChange={
              (e) =>
              {
                dispatch(updateMechanical({'TotalEstimateCost':e.target.value}))
              }
            }
          />
        </Box>

        <Typography variant="h5">
          Mechanical Characteristics
        </Typography>
        <Box sx={{ mt: 2, mb: 2 }}>
          <FormControl fullWidth>
            <InputLabel id="heating-system-label">Heating System Work</InputLabel>
            <Select
              labelId="heating-system-label"
              value={subCodesFormData?.HeatingSystem}
              label="Heating System Work"
              onChange={(e)=>{dispatch(updateMechanical({'HeatingSystem': e.target.value}))}}         
            >
              <MenuItem value="">
                <em>Select...</em>
              </MenuItem>
              <MenuItem value="New">New</MenuItem>
              <MenuItem value="Modification to Existing">Modification to Existing</MenuItem>
              <MenuItem value="Conversion">Conversion</MenuItem>
              <MenuItem value="Replacement">Replacement</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Type Field */}
        <Box sx={{ mt: 2, mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              sx={{
                fontWeight: 'bold',
                mr: 2,
                minWidth: '40px'
              }}
            >
              Type:
            </Typography>

            <Grid container spacing={2} alignItems="center">
              {heatingSystemType?.map((option, index) => (
                <Grid item key={option.value}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={option.check}
                        onChange={(e) => handleChange(index, 'check', e.target.checked)}
                        sx={{ p: 0.5 }}
                      />
                    </Box>
                    <Typography variant="body2" sx={{ ml: 1 }}>
                      {option.Item}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>

        {/* Fuel Type Field */}
        <Box sx={{ mt: 3 }}>
          <Typography
            sx={{
              fontWeight: 'bold',
              mb: 1
            }}
            variant="h5"
          >
            Fuel Type:
          </Typography>

          <Grid container spacing={1} alignItems="center">
            {fuelType?.map((option, index) => (
              <Grid item xs={12} sm={6} md={4} key={option.value}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      checked={option.check}
                      onChange={(e) => handleChange1(index, 'check', e.target.checked)}
                      sx={{ p: 0.5 }}
                    />
                  </Box>
                  <Typography variant="body2" sx={{ ml: 1 }}>
                    {option.Item}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* Show text field if "Other" is selected */}
          {fuelType?.find(option => option.Item === 'Other')?.check && (
            <Box sx={{ mt: 2, width: '100%' }}>
              <TextField
                fullWidth
                label="Specify other Fuel Type"
                value={fuelType?.find(option => option.Item === 'Other')?.Type}
                onChange={(e) =>{
                  const index = fuelType?.findIndex(item => item.Item === "Other")
                  const updatedFuelType = [...fuelType];
                  updatedFuelType[index] = {...updatedFuelType[index], Type: e.target.value}

    dispatch(
      updateMechanical({
        FuelType: updatedFuelType
      })
    );
                }}
                variant="outlined"

              />
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default MechanicalCharacteristics;